import React from 'react';

const formatAnalysisForEmail = (analysis, theme) => {
    if (!analysis) {
        return 'No analysis available';
    }

    const cleanAnalysis = analysis.toString().trim();
    const sections = {
        rootCause: cleanAnalysis.includes('Root Cause Analysis:') ? 
            cleanAnalysis.split('Root Cause Analysis:')[1].split('Why 1:')[0].trim() : '',
        whyAnalysis: []
    };

    // Extract Why sections
    for (let i = 1; i <= 5; i++) {
        const whySection = cleanAnalysis.includes(`Why ${i}:`) ? {
            problem: cleanAnalysis.split(`Why ${i}:`)[1]?.split('PROBLEM:')[1]?.split('INSIGHT:')[0]?.trim() || '',
            insight: cleanAnalysis.split(`Why ${i}:`)[1]?.split('INSIGHT:')[1]?.split('POSITION:')[0]?.trim() || '',
            position: cleanAnalysis.split(`Why ${i}:`)[1]?.split('POSITION:')[1]?.split('Why')[0]?.trim() || ''
        } : null;
        
        if (whySection) sections.whyAnalysis.push(whySection);
    }

    return `
        <table width="100%" cellpadding="0" cellspacing="0" border="0">
            <!-- Root Cause Analysis Section -->
            <tr>
                <td style="padding: 20px; background: ${theme.palette.primary.main}; color: ${theme.palette.text.primary}; border-radius: 8px">
                    <h2 style="margin: 0 0 16px">Root Cause Analysis</h2>
                    <div>${sections.rootCause}</div>
                </td>
            </tr>

            <!-- Why Analysis Grid -->
            <tr>
                <td style="padding: 16px 0">
                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                        ${sections.whyAnalysis.map((why, index) => `
                            <tr>
                                <td style="padding: 16px">
                                    <table width="100%" cellpadding="16" cellspacing="0" border="0" style="background: ${theme.palette.background.paper}; border: 1px solid ${theme.palette.divider}">
                                        <tr>
                                            <td>
                                                <h3 style="color: ${theme.palette.primary.main}; margin: 0">Why ${index + 1}</h3>
                                                <div style="margin-top: 16px">
                                                    <strong style="color: ${theme.palette.primary.main}">Problem:</strong>
                                                    <div>${why.problem}</div>
                                                    <strong style="color: ${theme.palette.primary.main}">Insight:</strong>
                                                    <div>${why.insight}</div>
                                                    <strong style="color: ${theme.palette.primary.main}">Position:</strong>
                                                    <div>${why.position}</div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        `).join('')}
                    </table>
                </td>
            </tr>

            <!-- Final Sections -->
            ${['AUDIENCE', 'VALIDATION', 'STRATEGY', 'NEXT_STEPS'].map(section => {
                const sectionContent = cleanAnalysis.includes(`[${section}]`) ? 
                    cleanAnalysis.split(`[${section}]`)[1]?.split('[')[0]?.trim() : '';
                
                return `
                    <tr>
                        <td style="padding: 16px 0">
                            <table width="100%" cellpadding="16" cellspacing="0" border="0" style="background: ${theme.palette.background.default}">
                                <tr>
                                    <td>
                                        <h3 style="color: ${theme.palette.primary.main}; margin: 0 0 16px">${section.replace('_', ' ')}</h3>
                                        <ol style="margin: 0; padding-left: 20px">
                                            ${sectionContent.split(/\d\.\s+/)
                                                .filter(item => item.trim())
                                                .map(item => `<li style="margin-bottom: 16px">${item.trim()}</li>`)
                                                .join('')}
                                        </ol>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                `;
            }).join('')}
        </table>
    `;
};

const EmailTemplate = ({ analysis, businessContext, problemStatement, rawAnswers, theme }) => {
    const formattedAnalysis = formatAnalysisForEmail(analysis, theme);
    
    return `
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto">
            <tr>
                <td style="padding: 20px; background: ${theme.palette.primary.main}; color: ${theme.palette.text.primary}">
                    <h1 style="margin: 0">${businessContext.businessName}</h1>
                    <p style="margin: 16px 0">Product: ${businessContext.solution}</p>
                    <p style="margin: 16px 0">Problem: ${problemStatement}</p>
                </td>
            </tr>
            <tr>
                <td style="padding: 20px">
                    ${formattedAnalysis}
                </td>
            </tr>
        </table>
    `;
};

export default EmailTemplate;